module.exports = require('./helpers/bundle-url').getBundleURL('h0ehp') + "reserved.27346904.png";